/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from '@/components/Common';

import { IconPosition } from '@/components/Common/TextField/TextField.types';
import { TextField } from '@/components/Common';
import { TextfieldType } from '@/components/Common/TextField/TextField.types';
import { Modal } from '@/components/Layout';
import { useEvaluationStore } from '@/store/EvaluationStore/EvaluationStore';
import { useEvaluation } from './Evaluation.hook';
import { FieldError } from 'react-hook-form';
import { useEffect } from 'react';

export const EvaluationForm = () => {
  const { isOpenModal } = useEvaluationStore();

  const {
    registerEvaluation,
    errorsEvaluation,
    onSubmitEvaluation,
    editingTab,
    setValueEvaluation,
    exercice,
    handleCloseModal,
    handleUpdateExercise,
    loadingExerciseCreation,
    loadingupdateQuestion,
  } = useEvaluation();

  useEffect(() => {
    if (exercice && editingTab) {
      setValueEvaluation('position', Number(exercice.position));
      setValueEvaluation('name', exercice.name);
      setValueEvaluation('duration', Number(exercice.duration));
    }
  }, [exercice, editingTab]);

  const onSubmit = editingTab ? handleUpdateExercise : onSubmitEvaluation;
  const isLoading = editingTab
    ? loadingupdateQuestion
    : loadingExerciseCreation;

  return (
    <Modal
      isOpen={isOpenModal}
      onClose={handleCloseModal}
      modalStyle="bg-bgModal"
      headerStyle="bg-bgModal h-[36px]"
    >
      <form onSubmit={onSubmit}>
        <div className="w-[315px]">
          <h1 className="mb-5 text-[20px] font-bold text-center text-white">
            {editingTab
              ? "Modifier l'exercice"
              : "Ajouter un exercice à l'évaluation"}
          </h1>
          <TextField
            className="mb-0 placeholder:text-iconColor"
            borderStyle="!bg-[#1D1D1D] pl-[22px]"
            name="position"
            register={registerEvaluation('position')}
            placeholder="Numéro d'exercice"
            textFieldType={TextfieldType.INPUT}
            iconPosition={IconPosition.LEFT}
            helpText={(errorsEvaluation.position as FieldError)?.message}
            errorStyle="!text-red-500 mb-2"
            type="number"
          />
          <TextField
            className="mb-0 placeholder:text-iconColor"
            borderStyle="!bg-[#1D1D1D] pl-[22px]"
            name="name"
            register={registerEvaluation('name')}
            placeholder="Nom de l'exercice"
            textFieldType={TextfieldType.INPUT}
            iconPosition={IconPosition.LEFT}
            errorStyle="!text-red-500 mb-2"
            helpText={(errorsEvaluation.name as FieldError)?.message}
          />
          <TextField
            className="mb-0 placeholder:text-iconColor"
            borderStyle="!bg-[#1D1D1D] pl-[22px]"
            name="duration"
            register={registerEvaluation('duration')}
            placeholder="Durée en minutes"
            helpText={(errorsEvaluation.duration as FieldError)?.message}
            errorStyle="!text-red-500"
            textFieldType={TextfieldType.INPUT}
            iconPosition={IconPosition.LEFT}
            type="number"
          />
        </div>
        <Button
          type="submit"
          title={
            isLoading
              ? editingTab
                ? 'Modification en cours...'
                : 'Ajout en cours...'
              : editingTab
                ? 'Modifier'
                : 'Ajouter'
          }
          className="w-full mt-10"
          disabled={isLoading}
        />
      </form>
    </Modal>
  );
};
